/* Envoi groupe : pour une commande mixte (articles en stock + precommande), une case propose d'attendre
   la precommande pour tout recevoir en un seul colis. Livraison a domicile uniquement (les points relais
   sont retires pour le moment). La reponse est enregistree dans les attributs de la commande (visible par
   l'equipe). Aucun blocage du paiement. */
(function () {
  if (window.__cmRelay) return;
  window.__cmRelay = true;

  var ATTR_COMBINE = 'Envoi groupe (attendre la precommande)';
  var saveTimer = null;
  var mounting = false;

  var css = document.createElement('style');
  css.textContent =
    '.cm-relay{margin:0 0 16px;padding:14px 16px;border-radius:16px;border:1px solid rgba(255,255,255,.3);background:rgba(238,93,161,.15);color:#fff;font-size:.9rem;line-height:1.45;text-align:left}' +
    '.cm-relay__title{margin:0 0 6px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:.85rem;color:#FFB0D8}' +
    '.cm-relay__combine{display:flex;align-items:flex-start;gap:8px;margin:0 0 10px;padding:10px 12px;border-radius:12px;border:1.5px solid #EC1E79;background:rgba(236,30,121,.18);cursor:pointer}' +
    '.cm-relay__combine input{margin-top:3px;flex:none;accent-color:#EC1E79}' +
    '.cm-relay__note{margin:0;font-weight:700}';
  document.head.appendChild(css);

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function isMixed(c) {
    var pre = false, stock = false;
    (c.items || []).forEach(function (i) {
      if (/Précommande/.test(i.product_title || i.title || '')) pre = true; else stock = true;
    });
    return pre && stock;
  }

  function save(cb) {
    var attrs = {};
    attrs[ATTR_COMBINE] = cb.checked ? 'Oui : tout expedier en un seul colis quand la precommande est prete' : 'Non : 2 colis (stock tout de suite, precommande ensuite)';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function refreshNote(root, cb) {
    root.querySelector('.cm-relay__note').textContent = cb.checked
      ? '📦 Tu recevras 1 seul colis, expédié quand la précommande est prête.'
      : '📦 Tu recevras 2 colis : le premier tout de suite, le second quand la précommande est prête.';
  }

  function build(c, host, ctas) {
    var attrs = c.attributes || {};
    var root = el('div', 'cm-relay');
    root.appendChild(el('p', 'cm-relay__title', '📦 Commande avec précommande'));
    var lab = el('label', 'cm-relay__combine');
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.setAttribute('data-role', 'combine');
    cb.checked = /^Oui/.test(attrs[ATTR_COMBINE] || '');
    lab.appendChild(cb);
    lab.appendChild(el('span', '', 'Je suis d’accord pour attendre la fin de la précommande afin de recevoir toute ma commande en un seul colis.'));
    root.appendChild(lab);
    root.appendChild(el('p', 'cm-relay__note'));
    refreshNote(root, cb);
    cb.addEventListener('change', function () {
      refreshNote(root, cb);
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () { save(cb); }, 400);
    });
    host.insertBefore(root, ctas);
    if (!attrs[ATTR_COMBINE]) save(cb);
  }

  function mount() {
    if (mounting) return;
    var targets = [];
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var host = ctas.parentElement;
      if (host && !host.querySelector(':scope > .cm-relay')) targets.push([host, ctas]);
    });
    if (!targets.length) return;
    mounting = true;
    getCart().then(function (c) {
      if (!c.item_count || !isMixed(c)) return;
      targets.forEach(function (t) {
        if (t[1].parentElement === t[0] && !t[0].querySelector(':scope > .cm-relay')) build(c, t[0], t[1]);
      });
    }).catch(function () {}).then(function () { mounting = false; });
  }

  new MutationObserver(function () { mount(); }).observe(document.body, { childList: true, subtree: true });
  mount();
})();
